import React from 'react'
import { Helmet } from "react-helmet";

import FormPage from '../FormPage'

class ForgotPassword extends FormPage
{
    static path = '/password/forgot';

	/**
	 * The css class for the page container
	 *
	 * @var {String}
	 */
	static BGClass = 'bordered-panel';

    /**
     * The title shown on the form
     */
	static FormTitle = 'passwords.forgot.title';

	/**
     * The submit button title for the form
     */
	static FormSubmit = 'passwords.forgot.submit_button';

	/**
     * The api endpoint path that the form should send a post request to
     */
	static FormPost = "/api/passwords/remind";

	/**
     * The fields mapping for the form
     */
    static FormFields = {
    	email: {
            type: 'email',
            label: 'passwords.forgot.email_label',
        },
    };

    /**
     * The links mapping for the form
     */
    static FormLinks = [
       	{
            title: 'passwords.forgot.login_link',
			path: '/login',
			columns: 12
		}
   	];

    /**
     * Whether or not an alert should show if the user tries to navigate to another page or close the browser
     *
     * @var {Boolean}
     */
    static ShowsUnloadWarning = false;

   	/**
     * Handles successful responses returned by TB Request
     *
     * @param {Object} responseData
     * @returns void
     */
	onSuccess(responseData)
	{
		TB.alert(
			'success',
			'passwords.forgot.success.title',
			'passwords.forgot.success.message'
		);
	}
}

export default () => {
     return (
          <>
               <Helmet>
                    <title>Forgot Password | Wripple</title>
               </Helmet>
               <ForgotPassword />
          </>
     )
 }
 